export default "__VITE_ASSET__B5US9MoA__"